module.exports = __webpack_public_path__ + "img/logo-argonne-bw.2758cd4a.png";